import { render, staticRenderFns } from "./EditLogShippingComponent.vue?vue&type=template&id=8938ac20&"
import script from "./EditLogShippingComponent.vue?vue&type=script&lang=js&"
export * from "./EditLogShippingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports